export const INIT_CONFIG_FIELDS = [
  'name',
  'sort_by',
  'website_url',
  'category_id',
  'sub_category_id',
  'platform',
  'inpage_skin',
  'display_name_in_say_control_for_guests',
  'languages',
  'scheme',
  'main_language',
  'brand_color',
  'font',
  'font_background_color',
  'initials_avatars',
  'numbered_avatars',
  'facebook_disabled',
  'google_disabled',
  'twitter_disabled',
  'email_disabled',
  'disqus_disabled',
  'microsoft_disabled',
  'comment_replies_max_depth',
  'rich_say_control_enabled',
  'giphy_level',
  'multiple_moderators_mode',
  'user_moderation_enabled',
  'sso_enabled',
  'emojis_enabled',
  'uppercase_msgs_enabled',
  'emoji_keyboard_enabled',
  'lazy_load_margin',
  'loading_indicator_enabled',
  'frame_script',
  'frame_style',
  'host_options',
  'monetized',
  'requires_mfa',
  'ltr'
];

export const MODERATION_SETTINGS_CONFIG_FIELDS = [
  'roger_mode',
  'display_name_in_say_control_for_guests',
  'allow_guests_to_like',
  'force_register'
];
